import React from "react";
import ButtonComponent from "@components/ButtonComponent";
import clsx from "clsx";

const DashboardHeader = ({ editMode, setEditMode, translate }) => {
  return (
    <div className="relative w-full flex">
      <ButtonComponent
        className={clsx(
          "absolute top-3",
          editMode ? "left-[calc(50%+5px)]" : "left-[calc(50%-30px)]"
        )}
        id="refresh-selection"
        color="blue"
        onClick={() => {
          setEditMode(!editMode);
        }}
        ref={null}
        icon={null}
        text={editMode ? translate("dashboard.done") : translate("dashboard.customize-layout")}
        width="max"
        size="sm"
        withoutborder={true}
        noTextSwap={true}
      />
    </div>
  );
};

export default DashboardHeader;
